module.exports = __webpack_public_path__ + "a522035f2ca117ae96f67070015173b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/games/Space-Marine_1.jpg
// module id = 265
// module chunks = 0